<template>
  <div class="reports">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <search-form
            ref="searchform"
            :showDates="true"
            :results="ocManagersFeed.rows"
            :totalResults="ocManagersFeed.count"
            :noResults="'No activity found for selected period.'"
            :options="{
              permalink: 'getOCManagersFeed'
            }">
          </search-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SearchForm from '@/components/SearchForm'
  import { mapGetters } from 'vuex'
  export default {
    name: 'OCManagersFeed',
    components: {
      SearchForm
    },
    computed: {
      ...mapGetters([
        'ocManagersFeed'
      ])
    },
    data () {
      return {
        autoReloadTimer: ''
      }
    },
    mounted () {
      this.autoReloadTimer = setInterval(this.autoReload, 600000)
    },
    beforeDestroy () {
      clearInterval(this.autoReloadTimer)
    },
    methods: {
      autoReload () {
        this.$refs.searchform.refresh()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/admin/OCManagersFeed.vue